import StringValueObject from "../domain/value-object/string-value-object";

export default class AnimeId extends StringValueObject {

}